export default {"src":"/_next/static/media/arrowRight.a6072182.svg","height":10,"width":12,"blurWidth":0,"blurHeight":0};